<template>
    <Head>
        <title>Menu Planner | NutriStudents K-12</title>
        <meta name="description" content="Calendar" />
    </Head>
    <FrontLayout>
        <div class="sr-only" aria-live="polite">{{ accessibilityAnnouncement }}</div>
        <div class="w-full flex lg:flex-wrap flex-wrap relative">
            <div class="w-full justify-end items-center bg-cover bg-center bg-no-repeat before:content-[''] before:bg-black before:w-full before:h-full before:opacity-60 before:block before:absolute"
                :style="{
                    'background-image':
                        'url(' +
                        bannerImage +
                        ')',
                    'background-size': 'cover',
                    'background-position': 'center'
                }">
                <div class="header_banner w-full lg:h-96 md:h-64 h-64 flex justify-center items-center pb-24">
                    <div class="lg:w-8/12 md:w-6/12 w-full z-10">
                        <h1
                            class="lg:text-7xl md:text-4xl text-4xl font-bold text-center text-white drop-shadow-lg px-3 capitalize">
                            {{ tenantName }}
                        </h1>
                    </div>
                </div>
            </div>
            <div
                class="lg:w-4/12 md:w-6/12 w-full flex lg:flex-nowrap flex-wrap lg:justify-end md:justify-end justify-start">
                <button v-if="is_week_available &&
                    form.type != 'group' &&
                    isShowHeadCount
                    "
                    class="button-color text-white text-sm font-bold py-2 xl:px-4 px-2 rounded lg:mt-0 sm:mt-4 uppercase">Update Student Counts</button>
            </div>
        </div>

        <!-- <PageTitleLayout> -->
        <div class="lg:flex justify-end items-center leading-3 xl:px-14 md:px-10 px-8 -mt-24 w-full">
            <div
                class="w-full flex xl:flex-nowrap flex-wrap justify-end items-center bg-white drop-shadow-sm rounded-t-lg py-5">
                <div class="xl:w-2/5 w-full md:flex xl:flex-nowrap flex-wrap items-center">
                    <h2 class="lg:text-3xl sm:text-2xl text-xl color-24 font-black pl-1 pr-2">
                        <inertia-link :href="$page.props.site_url +
                            '?month=' +
                            pre_month_array[0] +
                            '&year=' +
                            pre_month_array[1] +
                            '&site=' +
                            form.site +
                            '&guide_line_id=' +
                            form.guide_line_id +
                            '&type=' +
                            form.type +
                            '&offering_id=' +
                            form.offering_id
                            " aria-label="Previous Month"><i class="text-lg fa fa-chevron-left px-2" aria-hidden="true"></i><span class="sr-only">Previous Month</span></inertia-link>
                        {{ currentMonthName }} {{ get_year }}
                        <inertia-link :href="$page.props.site_url +
                            '?month=' +
                            next_month_array[0] +
                            '&year=' +
                            next_month_array[1] +
                            '&site=' +
                            form.site +
                            '&guide_line_id=' +
                            form.guide_line_id +
                            '&type=' +
                            form.type +
                            '&offering_id=' +
                            form.offering_id
                            " aria-label="Next Month"><i class="text-lg fa fa-chevron-right px-2" aria-hidden="true"></i><span class="sr-only">Next Month</span></inertia-link>
                    </h2>

                    <div class="flex p-color mt-3 md:mt-0 items-center">
                        <inertia-link :href="$page.props.site_url +
                            '?month=' +
                            currentMonth +
                            '&year=' +
                            currentYear +
                            '&site=' +
                            form.site +
                            '&guide_line_id=' +
                            form.guide_line_id +
                            '&type=' +
                            form.type +
                            '&offering_id=' +
                            form.offering_id
                            " class="px-2 p-color md:text-base text-sm underline">Today</inertia-link>
                        |
                        <a href="#" @click="changeMonthYearModalOpen"
                            class="pl-2 p-color md:text-base text-sm underline">Jump to...</a>
                    </div>
                </div>
                <div
                    class="xl:w-3/5 w-full xl:pl-12 pl-4 xl:pt-0 pt-6 flex md:flex-nowrap flex-wrap items-center xl:justify-end justify-start gap-y-2.5">

                    <div v-if="viewPage == 'calendar'" @click="toggleCalendar('list')" @keyup.enter="toggleCalendar('list')" @keyup.space="toggleCalendar('list')" class="mr-2.5 cursor-pointer"
                        :class="dayType != 'list' ? 'opacity-50 ' : ''" role="button" aria-label="List View" tabindex="0">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd"
                                d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                                clip-rule="evenodd" fill="#38558e"></path>
                        </svg>
                    </div>

                    <div v-if="viewPage == 'calendar'" @click="toggleCalendar('image')" @keyup.enter="toggleCalendar('image')" @keyup.space="toggleCalendar('image')" class="mr-2.5 cursor-pointer"
                        :class="dayType != 'image' ? 'opacity-50' : ''" role="button" aria-label="Image View" tabindex="0">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10 ml-2" viewBox="0 0 20 20"
                            fill="currentColor">
                            <path
                                d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                                fill="#38558e">
                            </path>
                        </svg>
                    </div>

                    <div @click="ChangePageView('day')" @keyup.enter="ChangePageView('day')" @keyup.space="ChangePageView('day')" class="mr-2.5 cursor-pointer" :class="viewPage != 'day' ? 'opacity-80' : ''" role="button" aria-label="Day View" tabindex="0">
                        <svg width="40px" height="40px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M22 14V12C22 11.161 22 10.4153 21.9871 9.75H2.0129C2 10.4153 2 11.161 2 12V14C2 17.7712 2 19.6569 3.17157 20.8284C4.34315 22 6.22876 22 10 22H14C17.7712 22 19.6569 22 20.8284 20.8284C22 19.6569 22 17.7712 22 14Z"
                                fill="#38558e" />
                            <path
                                d="M7.75 2.5C7.75 2.08579 7.41421 1.75 7 1.75C6.58579 1.75 6.25 2.08579 6.25 2.5V4.07926C4.81067 4.19451 3.86577 4.47737 3.17157 5.17157C2.47737 5.86577 2.19451 6.81067 2.07926 8.25H21.9207C21.8055 6.81067 21.5226 5.86577 20.8284 5.17157C20.1342 4.47737 19.1893 4.19451 17.75 4.07926V2.5C17.75 2.08579 17.4142 1.75 17 1.75C16.5858 1.75 16.25 2.08579 16.25 2.5V4.0129C15.5847 4 14.839 4 14 4H10C9.16097 4 8.41527 4 7.75 4.0129V2.5Z"
                                fill="#38558e" />
                        </svg>
                    </div>

                    <div v-if="!isMobile" @click="ChangePageView('calendar')" @keyup.enter="ChangePageView('calendar')" @keyup.space="ChangePageView('calendar')" class="mr-2.5 cursor-pointer"
                        :class="viewPage != 'calendar' ? 'opacity-80' : ''" role="button" aria-label="Calendar View" tabindex="0">
                        <svg width="40px" height="40px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M7.75 2.5C7.75 2.08579 7.41421 1.75 7 1.75C6.58579 1.75 6.25 2.08579 6.25 2.5V4.07926C4.81067 4.19451 3.86577 4.47737 3.17157 5.17157C2.47737 5.86577 2.19451 6.81067 2.07926 8.25H21.9207C21.8055 6.81067 21.5226 5.86577 20.8284 5.17157C20.1342 4.47737 19.1893 4.19451 17.75 4.07926V2.5C17.75 2.08579 17.4142 1.75 17 1.75C16.5858 1.75 16.25 2.08579 16.25 2.5V4.0129C15.5847 4 14.839 4 14 4H10C9.16097 4 8.41527 4 7.75 4.0129V2.5Z"
                                fill="#38558e" />
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M2 12C2 11.161 2 10.4153 2.0129 9.75H21.9871C22 10.4153 22 11.161 22 12V14C22 17.7712 22 19.6569 20.8284 20.8284C19.6569 22 17.7712 22 14 22H10C6.22876 22 4.34315 22 3.17157 20.8284C2 19.6569 2 17.7712 2 14V12ZM17 14C17.5523 14 18 13.5523 18 13C18 12.4477 17.5523 12 17 12C16.4477 12 16 12.4477 16 13C16 13.5523 16.4477 14 17 14ZM17 18C17.5523 18 18 17.5523 18 17C18 16.4477 17.5523 16 17 16C16.4477 16 16 16.4477 16 17C16 17.5523 16.4477 18 17 18ZM13 13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13C11 12.4477 11.4477 12 12 12C12.5523 12 13 12.4477 13 13ZM13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17ZM7 14C7.55228 14 8 13.5523 8 13C8 12.4477 7.55228 12 7 12C6.44772 12 6 12.4477 6 13C6 13.5523 6.44772 14 7 14ZM7 18C7.55228 18 8 17.5523 8 17C8 16.4477 7.55228 16 7 16C6.44772 16 6 16.4477 6 17C6 17.5523 6.44772 18 7 18Z"
                                fill="#38558e" />
                        </svg>
                    </div>

                    <div class="relative lg:w-56 sm:w-1/2 w-full h-12 mr-3 xl:mt-0">
                        <select aria-label="Select Site"
                            class="shadow-sm block border-gray-300 rounded-lg w-full select-menu-height text-lg text-[#4a4a4a] font-medium h-full"
                            v-model="form.site" @change="getOffering($event)">
                            <option value="">Choose Site</option>
                            <optgroup label="Site">
                                <option v-for="site in getDropdown(sites, 'site')" :value="site.id" :type="site.type">
                                    {{ site.name }}
                                </option>
                            </optgroup>

                        </select>

                        <div class="absolute flex justify-center items-center searching-background-color select-menu-height1 w-9 text-white top-0 bottom-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none bg-[#38558e !important] h-full"
                            style="
                                background-color: #38558e !important;
                                height: -webkit-fill-available;
                            ">
                            <i class="fa fa-sort-desc relative -top-1" aria-hidden="true"></i>
                        </div>
                    </div>

                    <div class="relative lg:w-56 sm:w-1/2 h-12 w-full mr-3 xl:mt-0"
                        v-if="form.type != 'group'">
                        <select aria-label="Select Offering"
                            class="shadow-sm block border-gray-300 rounded-lg w-full select-menu-height text-lg text-[#4a4a4a] font-medium h-full"
                            v-model="form.offering_id" @change="getGuidline($event)">
                            <option value="">Choose Offerings</option>
                            <option v-for="offer in offrings" :value="offer.id">
                                {{ offer.name }}
                            </option>
                        </select>

                        <div class="absolute flex justify-center items-center searching-background-color select-menu-height1 w-9 text-white top-0 bottom-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none h-full"
                            style="
                                background-color: #38558e !important;
                                height: -webkit-fill-available;
                            ">
                            <i class="fa fa-sort-desc relative -top-1" aria-hidden="true"></i>
                        </div>
                    </div>

                    <a href="#" aria-label="Print Calendar" @click="loadIsPrint(is_print)"><span class="sr-only">Print Calendar</span>
                        <svg xmlns="http://www.w3.org/2000/svg" class="
                xl:h-8
                w-8
                lg:h-8
                md:h-10
                w-10
                mr-3
                arrow-color
                md:mt-0
                mt-1
              " viewBox="0 0 20 20" fill="#ffc919">
                            <path fill-rule="evenodd"
                                d="M5 4v3H4a2 2 0 00-2 2v3a2 2 0 002 2h1v2a2 2 0 002 2h6a2 2 0 002-2v-2h1a2 2 0 002-2V9a2 2 0 00-2-2h-1V4a2 2 0 00-2-2H7a2 2 0 00-2 2zm8 0H7v3h6V4zm0 8H7v4h6v-4z"
                                clip-rule="evenodd" />
                        </svg>
                    </a>


                </div>
            </div>
        </div>
        <!-- </PageTitleLayout> -->

        <TableIndexLayout v-if="is_show_calendar && viewPage == 'calendar'">
            <div class="w-full">
                <div class="pb-14 align-middle inline-block xl:px-10 px-5 w-full relative mt-0 z-10">
                    <div class="shadow overflow-x-auto rounded-t-lg">
                        <table class="min-w-full shadow rounded-t-lg table-background">
                            <thead>
                                <tr class="searching-background-color">
                                    <th scope="col"
                                        class="px-6 py-3 text-center text-lg font-black text-white tracking-wider th-width ">
                                        Monday
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-center text-lg font-black text-white tracking-wider th-width">
                                        Tuesday
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-center text-lg font-black text-white tracking-wider th-width">
                                        Wednesday
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-center text-lg font-black text-white tracking-wider th-width">
                                        Thursday
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-center text-lg font-black text-white tracking-wider th-width">
                                        Friday
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-center text-lg font-black text-white tracking-wider th-width">
                                        Saturday
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-center text-lg font-black text-white tracking-wider th-width">
                                        Sunday
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- Odd row -->
                                <week-cycle v-for="(weeks, index) in calenderdays.weeks" @loadMenuCycle="loadMenuCycle"
                                    :weeks="weeks" :index="index" :graderanges="grade_ranges"
                                    :mealTypeImport="mealTypeImport" :daysImport="daysImport" :searchForm="form"
                                    :sites="sites" @loadCalendar="loadCalendar" :excludeDays="excludeDays"
                                    @loadExcludedDateDataOnLoad="loadExcludedDateDataOnLoad
                                        " @loadExcludedDateData="loadExcludedDateData" :isMenuPlanner="isMenuPlanner"
                                    :users="users" :is_loading="is_loading[index]" :viewPage="viewPage"
                                    :activeDay="activeDay" @checkActiveWeekCycle="checkActiveWeekCycle"
                                    :userLoginCheck="user_login_check" :dayType="dayType"></week-cycle>
                            </tbody>
                        </table>
                    </div>

                    <div class="w-full flex lg:flex-nowrap flex-wrap justify-end items-center mt-10">
                        <div
                            class="lg:w-4/12 md:w-6/12 w-full flex lg:flex-nowrap flex-wrap lg:justify-end md:justify-end justify-start">
                        </div>
                    </div>
                </div>
            </div>
        </TableIndexLayout>

        <div class="w-full mb-14 xl:px-10 px-5" v-else-if="is_show_calendar && viewPage == 'day'">
            <SingleDaySlide :weeks="calenderdays.weeks" :userLoginCheck="user_login_check" :excludeDays="excludeDays" />
        </div>
        <div v-else class="xl:px-10 px-5 mb-10 text-center lg:text-3xl md:text-2xl text-xl font-bold relative">
            <img class="" :src="$page.props.asset_url + '/vendor/nutristudents/image/calender-img.jpg'" alt="Calendar graphic">
            <span class="absolute top-0 left-0 right-0 bottom-0 pt-32 px-10 text-center bg-white bg-opacity-80">Please
                select a site/group and offering (if applicable) to view the Menu Planner.</span>
        </div>
    </FrontLayout>

    <jet-dialog-modal :show="changeMonthYearModal" @close="changeMonthYearModal = false" role="dialog" aria-modal="true">
        <template #title>
            <div class="flex justify-between items-center">
                Select Month and Year
            </div>
        </template>

        <template #content>
            <TableIndexLayout>
                <div class="-my-2">
                    <div class="py-2 align-middle inline-block px-2 w-full">
                        <div class="shadow overflow-x-auto max-height px-6 md:py-4 pb-4 pt-4 flex flex-wrap gap-3">
                            <div class="relative xl:w-56 w-48 h-12 mr-3 md:mt-0 mt-0">
                                <select aria-label="Select Month" v-model="form.month"
                                    class="shadow-sm block sm:text-sm border-gray-300 rounded-lg w-full h-full ">
                                    <option v-for="(month, index) in months" :value="index + 1">
                                        {{ month }}
                                    </option>
                                </select>
                                <div
                                    class="arrow_btn_coustam absolute flex justify-center items-center searching-background-color  w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none h-full">
                                    <i class="fa fa-sort-desc" aria-hidden="true"></i>
                                </div>
                            </div>

                            <div class="relative w-40 mr-3 md:mt-0 mt-0 h-12">
                                <select aria-label="Select Year" v-model="form.year"
                                    class="shadow-sm block sm:text-sm border-gray-300 rounded-lg w-full  h-full">
                                    <option v-for="year in years" :value="year">{{ year }}</option>
                                </select>
                                <div
                                    class="arrow_btn_coustam absolute flex justify-center items-center searching-background-color  w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none h-full">
                                    <i class="fa fa-sort-desc" aria-hidden="true"></i>
                                </div>
                            </div>
                            <button type="button"
                                class="text-white text-sm font-bold py-2 px-4 rounded uppercase mt-0 bg-[#38558e]"
                                @click="changeMonthYearRedirection">
                                Go to Calendar
                            </button>
                        </div>
                    </div>
                </div>
            </TableIndexLayout>
        </template>

        <template #footer>
            <jet-secondary-button @click="changeMonthYearModal = false">Close</jet-secondary-button>
        </template>
    </jet-dialog-modal>
    <CalendarPrint ref="CalendarPrint" :calender_days="calenderdays" :currentMonthName="currentMonthName" :site="form.site"
        :sites="sites" :get_year="get_year" :age_grade_offering="guidlineData?.age_grade?.name"
        :meal_type="guidlineData?.meal_type?.name" :excludeDays="excludeDays" :isFirstDaySunday="isFirstDaySunday">
    </CalendarPrint>
</template>

<script>
import FrontLayout from "@/Layouts/FrontLayout";
import Welcome from "@/Jetstream/Welcome";
import BreadcrumLayout from "@/Pages/Common/Breadcrumbs";
import PageTitleLayout from "@/Pages/Common/PageTitle";
import TableFilterLayout from "@/Pages/Common/TableFilters";
import TableIndexLayout from "@/Pages/Common/TableIndex";
import WeekCycle from "@/Pages/ParentPortal/Home/WeekCycle";
import WeekCycleForSingle from "@/Pages/ParentPortal/Home/WeekCycleForSingle";
import StudentCounts from "@/Pages/Calendar/StudentCounts";
import JetDialogModal from "@/Jetstream/DialogModal";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";
import CalendarPrint from "@/Pages/Calendar/CalendarPrint";
// import { provide } from 'vue';

import $ from "jquery";
import SingleDaySlide from "./SingleDaySlide";
var moment = require("moment");

export default {

    // setup() {
    //     provide('firstFunction',  this.loadExcludedDateData());
    //     provide('secondFunction',  this.loadCalendar());
    // },
    props: [
        "calender_days",
        "get_month",
        "get_year",
        "next_month",
        "next_year",
        "pre_month",
        "pre_year",
        "mealTypeImport",
        "daysImport",
        "grade_ranges",
        "meal_type",
        "age_grade_offering",
        "day",
        "site",
        "sites",
        "guide_line_id",
        "type",
        "offering_id",
        "users",
        "next_month_array",
        "pre_month_array",
        "isFirstDaySunday",
        "tenantName",
        "user_login_check",
        "years",
        "bannerImage"
    ],

    components: {
        FrontLayout,
        Welcome,
        BreadcrumLayout,
        PageTitleLayout,
        TableFilterLayout,
        TableIndexLayout,
        WeekCycle,
        WeekCycleForSingle,
        StudentCounts,
        JetDialogModal,
        JetSecondaryButton,
        SingleDaySlide,
        CalendarPrint,
    },

    data() {
        return {
            dayType: "image", //list, image
            activeDay: "",
            viewPage: "calendar",
            guidlineData: "",
            changeMonthYearModal: false,
            is_print: 0,
            is_loading: [false, false, false, false, false],
            isMobile: false,

            currentMonth: "",
            currentYear: "",
            currentMonthName: "",

            months: "",

            siteFilterVal: "",
            graderangeFilterVal: "",
            mealFilterVal: "",

            meal_types: [],

            calenderdays: [],
            offrings: [],
            excludeDays: [],

            excludedDates: [],
            form: this.$inertia.form({
                meal_type: this.meal_type,
                age_grade_offering: this.age_grade_offering,
                day: this.day,
                month: this.get_month,
                year: this.get_year,
                site: this.site,
                guide_line_id: this.guide_line_id,
                type: this.type,
                offering_id: this.offering_id,
                group_id: this.group_id,
            }),
            log: console.log,
            moment: moment,
            accessibilityAnnouncement: "",
        };
    },

    mounted() {
        this.checkIsMobile();
        window.addEventListener('resize', this.checkIsMobile);
        let date = new Date();
        this.months = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ];
        this.calenderdays = JSON.parse(JSON.stringify(this.calender_days));
        console.log("CalendarDays", this.calenderdays);
        this.currentMonthName = this.months[this.get_month - 1];
        this.currentMonth = date.getMonth() + 1;
        this.currentYear = date.getFullYear();
        if (this.site != "" && this.offering_id != "") {
            this.loadExcludedDateDataOnLoad(this.site, this.offering_id);
            this.loadCalendar(this.site, this.offering_id);
        }

        if (this.type == "group") {
            this.loadOffringsForGroup(this.site, this.guide_line_id);
        }
        if (this.type == "site") {
            this.loadOffrings(this.site, this.offering_id);
        }
    },
    computed: {
        isShowHeadCount: function () {
            if (this.form.offering_id != "") {
                if (this.offrings.length > 0) {
                    let offr = this.offrings.find(
                        (x) => x.id === this.form.offering_id
                    );
                    if (offr) {
                        return offr.is_headcount;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        isMenuPlanner: function () {
            if (this.form.type == "group") {
                return true;
            } else if (this.form.offering_id != "") {
                if (this.offrings.length > 0) {
                    let offr = this.offrings.find(
                        (x) => x.id === this.form.offering_id
                    );
                    if (offr) {
                        return offr.is_menuplanner;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        is_show_calendar: function () {
            if (
                this.form.meal_type &&
                this.form.meal_type != "" &&
                this.form.age_grade_offering &&
                this.form.age_grade_offering != "" &&
                this.form.day &&
                this.form.day != "" &&
                this.form.site != ""
            ) {
                return true;
            } else {
                return false;
            }
        },
        is_week_available: function () {
            let is_munu = false;
            if (this.calenderdays && this.calenderdays.weeks) {
                this.calenderdays.weeks.forEach((el1) => {
                    if (el1.menuCycle && el1.menuCycle != "") {
                        is_munu = true;
                    }
                });
            }

            return is_munu;
        },
        years() {
            var currentYear = this.moment().format('YYYY') - 6;
            var years = [];
            for (let index = 0; index < 9; index++) {
                years.push(currentYear);
                currentYear++;
            }
            console.log("year", years);
            return years;
        },
    },

    watch: {
        currentMonthName(val) {
            this.accessibilityAnnouncement = `Showing ${val} ${this.get_year}`;
        },
        get_year(val) {
            this.accessibilityAnnouncement = `Showing ${this.currentMonthName} ${val}`;
        },
        viewPage(val) {
            this.accessibilityAnnouncement = `Switched to ${val} View`;
        },
        dayType(val) {
            this.accessibilityAnnouncement = `Switched to ${val} View`;
        },
    },

    beforeUnmount() {
        window.removeEventListener('resize', this.checkIsMobile);
    },

    methods: {
        checkIsMobile() {
            const wasMobile = this.isMobile;
            this.isMobile = window.innerWidth <= 768;
            if (this.isMobile && !wasMobile) {
                this.ChangePageView('day');
            }
        },

        toggleCalendar(type) {
            this.dayType = type;
        },
        checkActiveWeekCycle(activeDay) {
            this.activeDay = activeDay;
        },

        getOffering(event) {
            console.log("eventsss", event);
            var options = event.target.options;

            var type = "";
            if (options.selectedIndex > -1) {
                type = options[options.selectedIndex].getAttribute("type");
            }
            this.form.type = type;
            this.emptyWeekCycles();

            if ("URLSearchParams" in window) {
                var searchParams = new URLSearchParams(window.location.search);
                searchParams.set("type", this.form.type);
                var newRelativePathQuery =
                    window.location.pathname + "?" + searchParams.toString();
                history.pushState(null, "", newRelativePathQuery);
            }

            if (type === "group") {
                this.form.offering_id = null;
                axios
                    .post("/get-offring-for-group-front", {
                        group_id: event.target.value,
                    })
                    .then((response) => {
                        this.form.site = event.target.value;
                        this.form.group_id = event.target.value;
                        this.offrings = response.data.offerings;
                        this.getGuidlineDataForGroup();
                    })
                    .catch((error) => console.error(error));
            }
            if (type === "site") {
                axios
                    .post("/get-offring-front", {
                        site_id: event.target.value,
                        type: "menu_planings,headcounts",
                        is_headcount: true,
                    })
                    .then((response) => {
                        this.form.site = event.target.value;
                        this.offrings = response.data;
                    })
                    .catch((error) => console.error(error));
            }
        },

        ChangePageView(type) {
            this.viewPage = type;
        },
        getDropdown(arrays, type) {
            let atype = [];
            arrays.forEach((site) => {
                if (site.type == type) {
                    atype.push(site);
                }
            });
            return atype;
        },
        getJsonToData(json_url) {
            let $this = this;
            console.log("getJsonToData", json_url);
            $.getJSON(json_url, function (json_data) {
                console.log("getJsonToData in ", json_data);
                $this.convertDataShowingCalendar(json_data);
                $this.hideShowLoader("hide");
            }).fail(function (e) {
                console.log("getJsonToData error ", e);
                // $this.menu_cycles = [];
                $this.hideShowLoader("hide");
            });
        },
        loadMenuCycle(menuCycle, index) {
            this.calenderdays.weeks[index]["menuCycle"] = menuCycle;
        },
        loadIsPrint(is_print) {
            this.is_print = true;

            if (
                this.is_print == true &&
                this.form.site != "" &&
                this.form.guide_line_id != ""
            ) {
                this.$refs.CalendarPrint.getCalenderDays();
                // var url = route("calendars", { month: this.form.month, year: this.form.year, site: this.form.site, guide_line_id: this.form.guide_line_id, is_print: 1, type: this.form.type, offering_id: this.form.offering_id })
                // console.log(url);
                setTimeout(function () {
                    var w = window.open("", "", "width=800,height=600");
                    w.document.write(
                        '<html><head><style type="text/css" media="print">'
                    );
                    w.document.write(
                        "* {-webkit-print-color-adjust: exact !important; color-adjust: exact !important; }.header,.left_part,.month_year{display:flex}body{font-family:Lato,sans-serif!important;padding:20px}.header{align-items:center;justify-content:space-between;padding:30px 0;width:100%}.month_year{background:rgba(30,67,127);border-radius:15px 15px 0 0;padding:16px 12px 10px;align-items:flex-end;justify-content:space-between;width:100%;box-sizing:border-box}.month_name{color:#fff;font-size:24px;font-weight:700}table.table{width:100%;border:none;line-height:1.2}table.table thead{background:#132d56}table.table thead th{color:#fff;vertical-align:bottom;padding:5px;border-right:2px solid #233b61;font-size:12px}table.table thead th:last-child{border-right:none}table.table tr.grey_bar td{background:#e8e8e8;border-right:2px solid #d9d9d9;border-bottom-color:#d9d9d9;padding:7px 5px 6px 10px;font-size:14px;color:#454545;font-weight:600;text-align:left}table.table tr td{font-size:11px;color:#454545;text-align:center;padding:20px 5px 10px;border-style:solid;border-color:#eee #eee #cecece;border-width:2px 2px 2px 0;line-height:1.1}table.table tr td:first-child{border-left:2px solid #eee}table.table tr td p{margin:0}table.table tr td p+p{margin-top:5px}@page{size:auto;margin:0}"
                    );
                    w.document.write("</style></head><body >");
                    w.document.write(
                        document.getElementById("print_calender").innerHTML
                    );
                    w.document.write("</body></html>");
                    w.document.close();
                    w.focus();

                    // w.document.write($('<div/>').append($('#print_calender').clone()).html());
                    // var w = window.open(url,"","width=800,height=600");
                    // try {
                    //   if(!document.execCommand('print', false, url)){
                    //     w.print();
                    //   }else{
                    //     w.print();
                    //   }
                    // }
                    // catch(e) {
                    //   w.print();
                    // }
                    w.print();
                    setTimeout(function () {
                        w.close();
                    }, 3000);
                }, 300);
            }
        },
        changeMonthYearModalOpen() {
            this.changeMonthYearModal = true;
        },

        changeMonthYearRedirection() {
            this.$inertia.visit(route("ParentPortalHome"), {
                method: "get",
                data: {
                    month: this.form.month,
                    year: this.form.year,
                    site: this.form.site,
                    guide_line_id: this.form.guide_line_id,
                    type: this.form.type,
                    offering_id: this.form.offering_id,
                },
            });
        },
        hideShowLoader(types) {
            if (types == "show") {
                document.getElementById("full_loader").style.display = "flex";
            } else {
                document.getElementById("full_loader").style.display = "none";
            }
        },

        useFullOptionNutritionValues(menuCycle) {
            if (!menuCycle || !Array.isArray(menuCycle.menu_cycle_days)) {
                return menuCycle;
            }

            menuCycle.menu_cycle_days.forEach((menuCycleDay) => {
                if (!Array.isArray(menuCycleDay.options)) {
                    return;
                }

                menuCycleDay.options.forEach((option) => {
                    if (option.new_total_val) {
                        option.total_val = { ...option.new_total_val };
                    }
                });
            });

            return menuCycle;
        },

        convertDataShowingCalendarByWeek(cal_week) {
            let $this = this;
            if (cal_week) {
                $this.calenderdays.weeks[cal_week.week_number]["menuCycle"] =
                    $this.useFullOptionNutritionValues(
                        $this.$helpers.convertMenuCycleToShowingData(
                            cal_week.menu_cycle,
                            $this.calenderdays.weeks[cal_week.week_number],
                            $this.$page.props.serve_logic
                        )
                    );
            }
            // if (cal_weeks.length > 0) {
            //   cal_weeks.forEach((cal_week) => {
            //     $this.calenderdays.weeks[cal_week.week_number]["menuCycle"] =
            //       $this.$helpers.convertMenuCycleToShowingData(
            //         cal_week.menu_cycle,
            //         $this.calenderdays.weeks[cal_week.week_number]
            //       );
            //   });
            // }
        },

        loadCalendarByWeek(weeks, attemp) {
            let $this = this;
            //this.emptyWeekCycles();
            if (this.is_show_calendar) {
                //this.hideShowLoader("show");
                let oids =
                    this.form.offering_id != "" ? this.form.offering_id : "1";
                $this.is_loading[weeks] = true;
                axios
                    .get(
                        "/load-menu-planner-by-week/" +
                        this.form.meal_type +
                        "/" +
                        this.form.age_grade_offering +
                        "/" +
                        this.form.day +
                        "/" +
                        this.form.month +
                        "/" +
                        this.form.year +
                        "/" +
                        this.form.site +
                        "/" +
                        this.form.guide_line_id +
                        "/" +
                        this.form.type +
                        "/" +
                        oids +
                        "/" +
                        weeks
                    )
                    .then((response) => {
                        $this.hideShowLoader('hide');
                        console.log("response", response);
                        if (response.data && response.data != "") {
                            // $this.convertDataShowingCalendarByWeek(response.data);
                            // $this.getJsonToData(response.data, weeks);
                            $this.getMenuCycleById(response.data, weeks);
                        } else {
                            $this.hideShowLoader("hide");
                            $this.is_loading[weeks] = false;
                        }

                        //$this.$helpers.convertMenuCycleToShowingData(response.data, this.weeks);
                    })
                    .catch((error) => {
                        $this.hideShowLoader("hide");
                        $this.is_loading[weeks] = false;
                        if (attemp <= 3) {
                            $this.loadCalendarByWeek(weeks, attemp + 1);
                        }
                    });
            }
        },

        async getMenuCycleById(menuPlannerDay, week_number) {
            const requests = [];
            var menu_cycle_days = [];
            console.log("getMenuCycleById", menuPlannerDay);
            for (var menu_cycle_day of menuPlannerDay.menu_cycle
                .menu_cycle_days) {
                console.log("getMenuCycleById menu_cycle_day", menu_cycle_day, menu_cycle_day.id);
                requests.push(
                    axios.get('/load-menu-planner-by-week-day-front/' + menu_cycle_day.id)
                        .then(response => {
                            menu_cycle_days.push(response.data);
                            console.log("load-menu-planner-by-week-day one by one", menu_cycle_days.length);
                        })
                        .catch(error => {
                            console.error('Error fetching data:', error);
                        })
                );
            }
            await Promise.all(requests);
            console.log("load-menu-planner-by-week-day all", menu_cycle_days);
            menuPlannerDay.menu_cycle.menu_cycle_days = menu_cycle_days;
            this.convertDataShowingCalendarByWeek(menuPlannerDay);
            this.is_loading[week_number] = false;
        },

        getJsonToData(json_url, weeks) {
            console.warn("json loading");
            let $this = this;
            console.log("getJsonToData");
            $this.paginates = [];
            $.getJSON(json_url, function (json_data) {
                $this.convertDataShowingCalendarByWeek(json_data);
                setTimeout(() => {
                    $this.is_loading[weeks] = false;
                }, 1000);
                console.log("getJsonToData json_data", json_data);
                $this.paginates = json_data.links;
                // $this.menu_cycles = $this.menu_cycles.concat(json_data.data);
                $this.menu_cycles = json_data.data;
                $this.next_page = json_data.next_page_url;
                $this.hideShowLoader("hide");
            }).fail(function () {
                // $this.menu_cycles = [];
                $this.hideShowLoader("hide");
            });
        },

        loadCalendar() {
            let $this = this;
            this.emptyWeekCycles();
            if (this.is_show_calendar) {
                this.hideShowLoader("show");
                $this.calenderdays.weeks.forEach((weekNum, indx) => {
                    console.log("weekNum", indx, weekNum);
                    $this.is_loading[indx] = true;
                    console.log("$this.is_loading", $this.is_loading);
                    $this.loadCalendarByWeek(indx, 1);
                });
            }
        },
        loadExcludedDateData() {
            axios
                .get(
                    "/load-exclude-dates/" +
                    this.form.site +
                    "/" +
                    this.form.offering_id
                )
                .then((response) => {
                    console.log("excluded data", response);
                    this.excludeDays = response.data;
                })
                .catch((error) => console.error(error));
        },

        loadExcludedDates(dates) {
            this.excludedDates = dates;
        },
        loadOffrings(site, offering_id) {
            axios
                .post("/get-offring-front", {
                    site_id: site,
                    type: "menu_planings,headcounts",
                    is_headcount: true,
                })
                .then((response) => {
                    this.form.site = site;
                    this.form.offering_id = offering_id;
                    this.form.guide_line_id = this.guide_line_id;
                    this.offrings = response.data;
                    this.getGuidlineData(offering_id);
                })
                .catch((error) => console.error(error));
        },
        loadOffringsForGroup(site, guide_line_id) {
            axios
                .post("/get-offring-for-group", {
                    group_id: site,
                })
                .then((response) => {
                    console.log("get-offring-for-group", response);
                    this.form.site = site;
                    this.form.guide_line_id = guide_line_id;
                    this.offrings = response.data;
                    this.getGuidlineDataForGroup();
                })
                .catch((error) => console.error(error));
        },
        loadExcludedDateDataOnLoad(site, guide_line_id) {
            axios
                .get("/load-exclude-dates/" + site + "/" + guide_line_id)
                .then((response) => {
                    this.excludeDays = response.data;
                })
                .catch((error) => console.error(error));
        },
        convertDataShowingCalendar(cal_weeks) {
            let $this = this;
            if (cal_weeks.length > 0) {
                cal_weeks.forEach((cal_week) => {
                    $this.calenderdays.weeks[cal_week.week_number][
                        "menuCycle"
                    ] = $this.useFullOptionNutritionValues(
                        $this.$helpers.convertMenuCycleToShowingData(
                            cal_week.menu_cycle,
                            $this.calenderdays.weeks[cal_week.week_number],
                            $this.$page.props.serve_logic
                        )
                    );
                });
            }
        },
        emptyWeekCycles() {
            console.log("emptyWeekCyclesCall", this.calenderdays);
            let $this = this;
            this.calenderdays.weeks.forEach((week, index) => {
                for (const day in week) {
                    // if (week.hasOwnProperty(day)) {
                    // Access individual days inside each week
                    const dayData = week[day];
                    console.log("Day in week", dayData);
                    // You can perform operations on 'dayData' here
                    // }
                }
                $this.calenderdays.weeks[index]["menuCycle"] = null;
            });
        },
        onGradeRangeChangeCalendarFilterMethod() {
            if (this.graderangeFilterVal == "") {
                this.$inertia.reload();
            } else {
                axios
                    .post("/menu-cycle-get-meal-types", {
                        grade_range: this.graderangeFilterVal,
                    })
                    .then((response) => {
                        this.meal_types = response.data;
                    })
                    .catch((error) => console.error(error));
            }
        },

        getGuidline(event) {
            if (event.target.value) {
                axios
                    .post("/get-guideline-for-front", {
                        id: event.target.value,
                    })
                    .then((response) => {
                        console.log("guidlineData", response);
                        this.guidlineData = response.data;
                        this.form.meal_type = response.data.meal_type_id;
                        this.form.age_grade_offering =
                            response.data.age_grade_id;
                        this.form.day = response.data.days_id;
                        this.form.month =
                            this.form.month != ""
                                ? this.form.month
                                : this.currentMonth;
                        this.form.year =
                            this.form.year != ""
                                ? this.form.year
                                : this.currentYear;
                        this.form.guide_line_id = response.data.id;
                        this.form.offering_id = event.target.value;
                        this.loadExcludedDateData();
                        this.loadCalendar();
                    })
                    .catch((error) => console.error(error));
            }
        },
        getGuidlineData(guide_line_id) {
            console.log("ewrq");
            if (guide_line_id) {
                axios
                    .post("/get-guideline-for-front", {
                        id: guide_line_id,
                    })
                    .then((response) => {
                        console.log("guidlineData", response);
                        this.guidlineData = response.data;

                        this.form.meal_type = response.data.meal_type_id;
                        this.form.age_grade_offering =
                            response.data.age_grade_id;
                        this.form.day = response.data.days_id;
                        this.form.month =
                            this.form.month != ""
                                ? this.form.month
                                : this.currentMonth;
                        this.form.year =
                            this.form.year != ""
                                ? this.form.year
                                : this.currentYear;
                        this.form.offering_id = guide_line_id;
                        this.form.guide_line_id = response.data.id;

                        this.loadCalendar();
                    })
                    .catch((error) => console.error(error));
            }
        },
        getGuidlineDataForGroup() {
            if (this.form.type === "group") {
                this.form.group_id = this.form.site;
            }
            console.log("im in", this.form.type);
            axios
                .post("/get-guideline-for-group", {
                    id: this.form.group_id,
                })
                .then((response) => {
                    console.log("guidlineData", response);
                    this.guidlineData = response.data;
                    this.form.meal_type = response.data.meal_type_id;
                    this.form.age_grade_offering = response.data.age_grade_id;
                    this.form.day = response.data.days_id;
                    this.form.month =
                        this.form.month != ""
                            ? this.form.month
                            : this.currentMonth;
                    this.form.year =
                        this.form.year != ""
                            ? this.form.year
                            : this.currentYear;
                    this.form.guide_line_id = response.data.id;
                    this.loadCalendar();
                })
                .catch((error) => console.error(error));
        },
    },
};
</script>

<style>
.splide__arrow {
    top: 3% !important;
    opacity: 1 !important;
}

div.select-menu-height.arrow_btn_coustam {
    background-color: #38558e !important;
    height: -webkit-fill-available !important;
}
</style>
<style>
.font-24 {
    font-size: 24px;
}

.color-24 {
    color: #636363;
}

.p-color {
    color: #595959;
}

.p-size {
    font-size: 15px;
}

.online-color {
    color: #22af4b;
}

.offline-color {
    color: #cb0000;
}

.number-background-color {
    background-color: #cb0000;
}

.online-background-color {
    background-color: #22af4b;
}

.offline-background-color {
    background-color: #cb0000;
}

.week-cycle-color {
    color: #1c2a47;
}

.week-cycle-fontsize {
    font-size: 14px;
}

.three-dot-color {
    color: #38558e;
}

.table-background {
    background-color: #f3f3f3;
}

.last-td-background {
    background-color: #f5f5f5;
}

.td-width {
    width: 14.28%;
    min-height: 170px;
    min-width: 170px;
}

.th-width {
    width: 14.28%;
    min-width: 170px;
}

.cart-color {
  color: #f7a53a;
}

.plus-font-size {
  font-size: 20px;
}

.menu-day-background {
  background-color: #cbcbcb;
}

.box-sizing {
  width: 100px;
  min-height: 60px;
}

i.text-lg {
    font-size: 16px;
    line-height: inherit;
    vertical-align: top;
    position: relative;
    top: 1px;
}

.select-menu-height i,
.select-menu-height i:before {
    line-height: 0;
    display: inline-table;
}

.box-hover .bg-white.popup-shadow {
    font-size: 12px;
    width: 141px;
}

.box-hover .bg-white.popup-shadow li.text-black {
    padding: 0 8px;
}

table.table-background tr:last-child td table.table-background tr:last-child td .bg-white.popup-shadow {
    bottom: 0;
    top: auto;
}
</style>
